import React from 'react';
import EditPatientModal2 from "../Organisms/EditPatientModal2";
import CookieModal from "../Modals/CookieModal/CookieModal";
import ModalsStore from './Modals.store'
import {observer} from "mobx-react";
import AssistantsModal from "../Organisms/AssistantsModal";
import QuizMammoModal from "../Organisms/QuizMammoModal";
import QuizRentgenModal from "../Organisms/QuizRentgenModal";
import QuizVeterinarModal from "../Organisms/QuizVeterinarModal";


const Modals = observer((props) => {
    const modalsCatalog = [
        {store: ModalsStore.Modals.EditPatient2, Component: <EditPatientModal2/>},
        {store: ModalsStore.Modals.AssistantsModal, Component: <AssistantsModal API={''}/>},
        {store: ModalsStore.Modals.QuizMammoModal, Component: <QuizMammoModal/>},
        {store: ModalsStore.Modals.QuizRentgenModal, Component: <QuizRentgenModal/>},
        {store: ModalsStore.Modals.QuizVeterinarModal, Component: <QuizVeterinarModal/>},
    ]
    return (
        <>
            {modalsCatalog.map(
                Modal => Modal.store.visibility && Modal.Component
            )}
            <CookieModal/>
        </>
    );
})

export default Modals;